import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StatusToastType } from './types';

interface StatusToastState {
  value: StatusToastType[];
}

const initialState: StatusToastState = {
  value: [],
};

export const statusToastSlice = createSlice({
  name: 'statusToasts',
  initialState,
  reducers: {
    addStatusToast: (state, action: PayloadAction<StatusToastType>) => {
      // Add timestamp now to toast
      action.payload.Timestamp = Date.now();

      state.value.push(action.payload);

      // Keep state clean by removing very old toasts if the list grows too large
      if (state.value.length > 20) {
        state.value = state.value.slice(-20);
      }
    },
    clearStatusToasts: state => {
      state.value = [];
    },
  },
});

export const { addStatusToast, clearStatusToasts } = statusToastSlice.actions;

export const selectStatusToasts = state => state.statusToast.value;

export default statusToastSlice.reducer;
